module.exports = __webpack_public_path__ + "img/vn_qrcode_wechat.1e9ca5b.webp";